module.exports = __webpack_public_path__ + "img/hh5.39aabf4b.png";